<template lang="pug">
div
  v-container.py-6.px-8
    div.d-flex
      v-btn(text small icon @click="goBack")
        eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].neutral700" width="24" height="24")
      div.ml-4
        div.text-xl.font-semibold.neutral700--text {{ $t('whatsapp_message_template') }}
        div.text-md.font-normal.basic700--text {{ $t('whatsapp_message_template_desc') }}
    v-divider.my-6

    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    
    template(v-else)
      upcoming-reminder-template(:upcomingReminder.sync="upcomingReminder")
      v-divider.my-6
      review-reminder-template(:reviewReminder.sync="reviewReminder")
      v-divider.my-6
      absent-reminder-template(:absentReminder.sync="absentReminder")

</template>

<script>
import { mapGetters } from 'vuex'
import UpcomingReminderTemplate from '@/components/clinic/appointment/UpcomingReminderTemplate.vue'
import ReviewReminderTemplate from '@/components/clinic/appointment/ReviewReminderTemplate.vue'
import AbsentReminderTemplate from '@/components/clinic/appointment/AbsentReminderTemplate.vue'

export default {
  name: 'MessageTemplate',
  components: { UpcomingReminderTemplate, ReviewReminderTemplate, AbsentReminderTemplate },
  props: ['id'],
  data () {
    return {
      isFetching: false,
      upcomingReminder: null,
      reviewReminder: null,
      absentReminder: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  mounted () {
    this.fetchTemplateMessage()
  },
  methods: {
    fetchTemplateMessage () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}`)
        .then(resp => {
          this.upcomingReminder = resp.data.upcoming_reminder
          this.reviewReminder = resp.data.review_reminder
          this.absentReminder = resp.data.absent_reminder
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  destroyed () {
    this.$store.commit('clinic/resetClinic')
  }
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>